import { render, staticRenderFns } from "./friendsrequest.vue?vue&type=template&id=3b133806&scoped=true"
import script from "./friendsrequest.vue?vue&type=script&lang=js"
export * from "./friendsrequest.vue?vue&type=script&lang=js"
import style0 from "./friendsrequest.vue?vue&type=style&index=0&id=3b133806&lang=scss"
import style1 from "./friendsrequest.vue?vue&type=style&index=1&id=3b133806&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b133806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b133806')) {
      api.createRecord('3b133806', component.options)
    } else {
      api.reload('3b133806', component.options)
    }
    module.hot.accept("./friendsrequest.vue?vue&type=template&id=3b133806&scoped=true", function () {
      api.rerender('3b133806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/friendsrequest.vue"
export default component.exports